module.exports = __webpack_public_path__ + "static/integration/custom/canvas.a082890000b6edb87af572b39eceba1c.css";